class ContatosActionTypes {
  constructor() {
    this.SET_CONTATOS = 'SET_CONTATOS';
    this.ADD_CONTATO = 'ADD_CONTATO';
    this.REMOVE_CONTATO = 'REMOVE_CONTATO';
    this.CLEAR_CONTATOS = 'CLEAR_CONTATOS';
  }
}

export default new ContatosActionTypes();
